/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Recentactivity1Inputs */

const id_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitas terbaru`)
};

const ms_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviti terkini`)
};

const da_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste aktivitet`)
};

const de_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Aktivität`)
};

const en_us2_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent activity`)
};

const es_es2_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad reciente`)
};

const es_mx2_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad reciente`)
};

const fil_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamakailang aktibidad`)
};

const fr_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité récente`)
};

const it_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività recente`)
};

const hu_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbbi tevékenység`)
};

const nl_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente activiteit`)
};

const no_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nylig aktivitet`)
};

const pl_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktywność`)
};

const pt_br2_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade recente`)
};

const pt_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade recente`)
};

const ro_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activitate recentă`)
};

const fi_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisin toiminta`)
};

const sv_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste aktivitet`)
};

const vi_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động gần đây`)
};

const tr_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son aktivite`)
};

const cs_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedávná aktivita`)
};

const bg_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорошна активност`)
};

const ru_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недавняя активность`)
};

const uk_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недавня активність`)
};

const ar_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشاط الأخير`)
};

const hi_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल की गतिविधि`)
};

const th_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรมล่าสุด`)
};

const ja_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近のアクティビティ`)
};

const zh_cn2_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期活动`)
};

const zh_hant1_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期活動`)
};

const ko_home_pulse_recentactivity1 = /** @type {(inputs: Home_Pulse_Recentactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최근 활동`)
};

/**
* | output |
* | --- |
* | "Recent activity" |
*
* @param {Home_Pulse_Recentactivity1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_recentactivity1 = /** @type {((inputs?: Home_Pulse_Recentactivity1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Recentactivity1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_recentactivity1(inputs)
	if (locale === "ms") return ms_home_pulse_recentactivity1(inputs)
	if (locale === "da") return da_home_pulse_recentactivity1(inputs)
	if (locale === "de") return de_home_pulse_recentactivity1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_recentactivity1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_recentactivity1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_recentactivity1(inputs)
	if (locale === "fil") return fil_home_pulse_recentactivity1(inputs)
	if (locale === "fr") return fr_home_pulse_recentactivity1(inputs)
	if (locale === "it") return it_home_pulse_recentactivity1(inputs)
	if (locale === "hu") return hu_home_pulse_recentactivity1(inputs)
	if (locale === "nl") return nl_home_pulse_recentactivity1(inputs)
	if (locale === "no") return no_home_pulse_recentactivity1(inputs)
	if (locale === "pl") return pl_home_pulse_recentactivity1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_recentactivity1(inputs)
	if (locale === "pt") return pt_home_pulse_recentactivity1(inputs)
	if (locale === "ro") return ro_home_pulse_recentactivity1(inputs)
	if (locale === "fi") return fi_home_pulse_recentactivity1(inputs)
	if (locale === "sv") return sv_home_pulse_recentactivity1(inputs)
	if (locale === "vi") return vi_home_pulse_recentactivity1(inputs)
	if (locale === "tr") return tr_home_pulse_recentactivity1(inputs)
	if (locale === "cs") return cs_home_pulse_recentactivity1(inputs)
	if (locale === "bg") return bg_home_pulse_recentactivity1(inputs)
	if (locale === "ru") return ru_home_pulse_recentactivity1(inputs)
	if (locale === "uk") return uk_home_pulse_recentactivity1(inputs)
	if (locale === "ar") return ar_home_pulse_recentactivity1(inputs)
	if (locale === "hi") return hi_home_pulse_recentactivity1(inputs)
	if (locale === "th") return th_home_pulse_recentactivity1(inputs)
	if (locale === "ja") return ja_home_pulse_recentactivity1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_recentactivity1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_recentactivity1(inputs)
	return ko_home_pulse_recentactivity1(inputs)
});
export { home_pulse_recentactivity1 as "home.pulse.recentActivity" }